import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

const types = {
  mobile: ['MOBILE', 'FIXED_LINE_OR_MOBILE'],
  fixed: ['FIXED_LINE', 'FIXED_LINE_OR_MOBILE', 'VOIP'],
  both: ['MOBILE', 'FIXED_LINE', 'FIXED_LINE_OR_MOBILE', 'VOIP']
};
const messagesTypes = {
  mobile: 'un numéro de mobile',
  fixed: 'un numéro de téléphone fixe',
  both: 'un numéro de mobile ou de fixe'
};

function extendPhone (validator) {
  validator.extend('phone', {
    getMessage: (field, { phoneType = 'both' }, data) => ({
      undefined: field => 'Ce numéro ne semble pas exister.',
      country: field => 'Le champ ' + field + ' n\'appartient pas au bon pays.',
      type: field => 'Le champ ' + field + ' doit être ' + messagesTypes[phoneType] + '.'
    })[data](field),
    validate: (input, { phoneType = 'both', defaultCountry, acceptedCountries } = {}) => {
      console.log(input, {acceptedCountries, phoneType});
      const phone = parsePhoneNumberFromString(input, defaultCountry);
      console.log(phone, {acceptedCountries, phoneType});
      if(phone) {
        console.log(phone.getType())
      }
      return {
        valid:
          phone !== undefined && phone.isValid() &&
          (phone.country === undefined || acceptedCountries.includes(phone.country)) &&
          types[phoneType].includes(phone.getType()),
        data:
        phone === undefined || !phone.isValid() ? 'undefined' : (
          (phone.country !== undefined && !acceptedCountries.includes(phone.country)) ? 'country' : (
            (!types[phoneType].includes(phone.getType())) ? 'type' : 'undefined'

          )
        )
      };
    }
  }, ['phoneType', 'defaultCountry', 'acceptedCountries']);
}
export default extendPhone;
